import styled from "styled-components";

export const StyledReportsContainer = styled.div`
  width: 350px;
  height: calc(100% - 160px);
  position: absolute;
  transform: translateX(-100%);
  top: 58px;
  background: var(--backgroundTransparentSecondary);
  backdrop-filter: var(--backdropFilterSecondary);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const StyledCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
  flex: 1;
  padding: ${({ hasPadding }) => (hasPadding ? "0px 8px 8px 8px" : "0")};
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 54px;
  box-sizing: border-box;
  padding: 0px 8px;
`;

export const StyledHeaderTitle = styled.span`
  font-size: 16px;
  color: var(--fontColor);
  font-weight: 500;
  margin: auto;
`;

export const StyledHeaderButton = styled.div`
  width: 14px;
  height: 14px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
